import { FC } from 'react';
import { AllieLabel, AllieSelect, AllieText } from '../../../components';
import { StyledFilterBarDesktopContainer } from '../FilterBar/FilterBar.styles';
import { getDisplayText } from '../FilterBar/utils';
import { FilterBarPropsV2 } from './FilterBarV2';

const namespace = 'filter-bar-desktop';

export const AllieFilterBarDesktopV2: FC<FilterBarPropsV2> = ({
  filters,
  labelAll,
  labelMultiple,
  labelFilterBy,
  className,
  style,
}) => {
  return (
    <StyledFilterBarDesktopContainer style={style}>
      {labelFilterBy && <AllieLabel className={`${namespace}__label`}>{labelFilterBy}</AllieLabel>}
      <div className={`${namespace}__container-item`}>
        {filters.map(
          ({
            label,
            getOptions,
            component,
            handleChange,
            selected,
            disabled,
            multiple,
            interfaceOptions,
          }) => {
            const options = getOptions?.(labelAll);
            const displayText = getDisplayText(options || [], selected, labelAll, labelMultiple);

            return (
              component || (
                <div className={`${namespace}__item`}>
                  <AllieText
                    className={`${namespace}__label`}
                    type="body3"
                    weight={400}
                    color="neutral-50"
                  >
                    {label}
                  </AllieText>
                  <AllieSelect
                    className={`${namespace}__item__select`}
                    options={options || []}
                    color={{
                      backgroundColor: 'white',
                      allieColor: 'neutral-90',
                    }}
                    selectedText={displayText}
                    selected={selected}
                    placeholder={labelAll}
                    onChange={handleChange}
                    disabled={disabled}
                    multiple={multiple}
                    interfaceOptions={{
                      className,
                      arrow: false,
                      size: 'cover',
                      ...interfaceOptions,
                    }}
                  />
                </div>
              )
            );
          }
        )}
      </div>
    </StyledFilterBarDesktopContainer>
  );
};
